import { createContext, useContext } from 'react';

export interface LightboxImage {
  id: string;
  src: string;
  alt: string;
  origin: ImageRect;
  aspectRatio: number;
}

export interface ImageRect {
  top: number;
  left: number;
  width: number;
  height: number;
}

export interface ImageLightboxContextValue {
  openImage: (image: LightboxImage) => void;
  activeImageId: string | null;
}

export const ImageLightboxContext =
  createContext<ImageLightboxContextValue | null>(null);

export function useImageLightbox() {
  const context = useContext(ImageLightboxContext);
  if (!context) {
    throw new Error(
      'useImageLightbox mora biti korišćen unutar ImageLightboxProvider komponente.'
    );
  }
  return context;
}
